import React from "react"
import Header from "./header"
import Footer from "./footer"

class Layout extends React.Component {
  render() {
    const { children } = this.props

    return (
      <React.Fragment>
        <Header />
        <section>{children}</section>
        <Footer />
      </React.Fragment>
    )
  }
}

export default Layout
